/**
 * en-GB messages added by Phase 4 task W27 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w27EnGB = {
    // Integrations page
    'p4w27.int.title': 'Integrations',
    'p4w27.int.description': 'Send alerts to Slack and Microsoft Teams, and keep your people list in step with Microsoft 365.',
    'p4w27.int.otherLinks': 'Related settings',
    'p4w27.int.linkOmp': 'Oakford Mobile Portal link',
    'p4w27.int.linkClients': 'API clients',
    // Slack and Teams connections
    'p4w27.conn.slack.title': 'Slack',
    'p4w27.conn.teams.title': 'Microsoft Teams',
    'p4w27.conn.slack.description': 'Post messages to a Slack channel. Notification rules can then use the connection.',
    'p4w27.conn.teams.description': 'Post messages to a Microsoft Teams channel. Notification rules can then use the connection.',
    'p4w27.conn.add': 'Add a connection',
    'p4w27.conn.empty': 'No connections yet.',
    'p4w27.conn.listLabel': '{kind} connections',
    'p4w27.conn.name': 'Name',
    'p4w27.conn.nameHint': 'Shown when you pick the connection in a notification rule, for example "Front desk channel".',
    'p4w27.conn.url': 'Web address',
    'p4w27.conn.urlHint': 'Paste the address here. For safety it is stored encrypted and can never be shown again.',
    'p4w27.conn.urlNew': 'New web address (leave empty to keep the current one)',
    'p4w27.conn.save': 'Save connection',
    'p4w27.conn.edit': 'Edit',
    'p4w27.conn.editLabel': 'Edit {name}',
    'p4w27.conn.test': 'Send a test',
    'p4w27.conn.testLabel': 'Send a test message to {name}',
    'p4w27.conn.testOk': 'The test message was sent.',
    'p4w27.conn.testFailed': 'The test message could not be sent.',
    'p4w27.conn.testTime': 'Answered in {ms} ms.',
    'p4w27.conn.disable': 'Switch off',
    'p4w27.conn.enable': 'Switch on',
    'p4w27.conn.toggleLabel': '{action} {name}',
    'p4w27.conn.deleted': 'Connection deleted.',
    'p4w27.conn.delete': 'Delete',
    'p4w27.conn.deleteConfirm': 'Delete connection',
    'p4w27.conn.deleteWarning': 'Rules that use a deleted connection are switched off and their owners are emailed.',
    'p4w27.conn.status.active': 'Working',
    'p4w27.conn.status.failing': 'Failing',
    'p4w27.conn.status.disabled': 'Switched off',
    'p4w27.conn.failures': '{count} failed attempts in a row.',
    'p4w27.conn.lastUsed': 'Last used {when}',
    'p4w27.conn.neverUsed': 'Not used yet',
    'p4w27.conn.cancel': 'Cancel',
    'p4w27.conn.stepsTitle': 'How to get this address',
    'p4w27.conn.slack.step1': 'In Slack, open the apps directory and add "Incoming Webhooks" to your workspace.',
    'p4w27.conn.slack.step2': 'Choose the channel to post in and select "Add Incoming Webhooks integration".',
    'p4w27.conn.slack.step3': 'Copy the Webhook URL. It starts with https://hooks.slack.com/.',
    'p4w27.conn.teams.step1': 'In Microsoft Teams, open the channel, select the three dots, then "Workflows".',
    'p4w27.conn.teams.step2': 'Choose "Post to a channel when a webhook request is received" and finish the set-up.',
    'p4w27.conn.teams.step3': 'Copy the web address Teams shows at the end.',
    // Microsoft 365
    'p4w27.m365.title': 'Microsoft 365 directory sync',
    'p4w27.m365.description': 'Add and update people from Microsoft 365 groups. People who leave a group are archived, never deleted.',
    'p4w27.m365.unavailable': 'Microsoft 365 is not set up for this CloudSign service yet. Ask your CloudSign contact.',
    'p4w27.m365.notConnected': 'Not connected.',
    'p4w27.m365.connected': 'Connected {when}.',
    'p4w27.m365.connect': 'Connect to Microsoft 365',
    'p4w27.m365.disconnect': 'Disconnect',
    'p4w27.m365.disconnectConfirm': 'Disconnect Microsoft 365',
    'p4w27.m365.disconnectNote': 'Your group links are kept, but syncing stops.',
    'p4w27.m365.justConnected': 'Microsoft 365 is connected.',
    'p4w27.m365.lastRun': 'Last sync {when}',
    'p4w27.m365.neverRun': 'No sync has run yet.',
    'p4w27.m365.runStatus.ok': 'Finished',
    'p4w27.m365.runStatus.partial': 'Finished with some problems',
    'p4w27.m365.runStatus.failed': 'Failed',
    'p4w27.m365.runStatus.stopped': 'Stopped for safety',
    'p4w27.m365.runStatus.running': 'Running',
    'p4w27.m365.syncNow': 'Sync now',
    'p4w27.m365.preview': 'Preview changes',
    'p4w27.m365.started': 'The sync has started.',
    'p4w27.m365.previewStarted': 'The preview has started. Nothing will be changed.',
    'p4w27.m365.mappings': 'Linked groups',
    'p4w27.m365.mappingsEmpty': 'No groups linked yet.',
    'p4w27.m365.mappingsLabel': 'Linked Microsoft 365 groups',
    'p4w27.m365.entraGroup': 'Microsoft 365 group',
    'p4w27.m365.cloudGroup': 'CloudSign group',
    'p4w27.m365.phoneSource': 'Phone number from',
    'p4w27.m365.phone.mobilePhone': 'Mobile phone',
    'p4w27.m365.phone.businessPhones': 'Business phone',
    'p4w27.m365.phone.none': 'Do not copy a phone number',
    'p4w27.m365.archiveMissing': 'Archive people who leave the group',
    'p4w27.m365.enabled': 'Enabled',
    'p4w27.m365.remove': 'Remove link',
    'p4w27.m365.removeConfirm': 'Remove this link',
    'p4w27.m365.search': 'Search Microsoft 365 groups',
    'p4w27.m365.searchButton': 'Search',
    'p4w27.m365.searchNone': 'No groups found.',
    'p4w27.m365.members': '{count} people',
    'p4w27.m365.link': 'Link this group',
    'p4w27.m365.linkLabel': 'Link {name}',
    'p4w27.m365.pickGroup': 'Choose a CloudSign group',
    'p4w27.m365.runs': 'Recent syncs',
    'p4w27.m365.runsEmpty': 'No syncs yet.',
    'p4w27.m365.runsLabel': 'Recent syncs',
    'p4w27.m365.run.started': 'Started',
    'p4w27.m365.run.kind': 'Type',
    'p4w27.m365.run.trigger.schedule': 'Automatic',
    'p4w27.m365.run.trigger.manual': 'By hand',
    'p4w27.m365.run.trigger.preview': 'Preview',
    'p4w27.m365.run.result': 'Result',
    'p4w27.m365.run.counts': '{created} added, {updated} updated, {archived} archived, {restored} restored, {skipped} skipped',
    'p4w27.m365.run.problem': '{count} x {problem}',
    // Rule builder channels
    'p4w27.rule.channel.slack': 'Slack',
    'p4w27.rule.channel.teams': 'Microsoft Teams',
    'p4w27.rule.connection': 'Connection',
    'p4w27.rule.connectionHint': 'The Slack or Teams channel that receives the message.',
    'p4w27.rule.chooseConnection': 'Choose a connection',
    'p4w27.rule.noConnections': 'There are no active connections of this type yet.',
    'p4w27.rule.manageConnections': 'Add one on the Integrations page',
    'p4w27.rule.connectionRequired': 'Choose a connection.',
    'p4w27.rule.connectionsUnavailable': 'Connections could not be loaded. You may not have access to Integrations.',
    // API clients, Phase 4
    'p4w27.api.expires': 'Expires',
    'p4w27.api.neverExpires': 'Never',
    'p4w27.api.expired': 'Expired',
    'p4w27.api.rate': 'Request limit',
    'p4w27.api.rateDefault': 'Standard limit',
    'p4w27.api.rateValue': '{count} per minute',
    'p4w27.api.expiryLabel': 'Expiry date',
    'p4w27.api.expiryHint': 'Leave empty if the key should never expire. After this date the key stops working.',
    'p4w27.api.rateLabel': 'Lower the request limit (per minute)',
    'p4w27.api.rateHint': 'Leave empty for the standard limit. You can only lower it.',
    'p4w27.api.docs': 'API documentation',
    'p4w27.api.docsHelp': 'The OpenAPI document lists every request your keys can make, and the access each one needs.',
    'p4w27.api.group.read': 'Read information',
    'p4w27.api.group.write': 'Add and change records',
    'p4w27.api.group.signin': 'Sign in and out',
    'p4w27.api.edit': 'Edit limits',
    'p4w27.api.editLabel': 'Edit limits for {name}',
    'p4w27.api.editSave': 'Save limits',
    'p4w27.api.saved': 'Limits saved.',
};
//# sourceMappingURL=w27.js.map